import * as React from "react";
import { connect } from "react-redux";
import { IdStyles } from "../../less/IdStyles";
import { selectFbConnectedServerAccount, selectFbConnectedWebAccount, } from "../../selectors/selectFbConnectedAccountInfo";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { DialogWrapper } from "../dialog/DialogWrapper";
import { actionModalClose, actionModalOpen } from "../modals/actionModal";
import { IdModal } from "../modals/IdModal";
import { HudXp } from "../xp/HudXp";
import { XpBar } from "../xp/XpBar";
import { ProfileQuickInfo } from "./ProfileQuickInfo";
var DialogFacebookAnotherPlayerConnectedDOM = function (_a) {
    var onClose = _a.onClose, onFromServerSelect = _a.onFromServerSelect, onFromWebSelect = _a.onFromWebSelect, serverConnectedAccountInfo = _a.serverConnectedAccountInfo, webConnectedAccountInfo = _a.webConnectedAccountInfo;
    var xp = serverConnectedAccountInfo.xp, level = serverConnectedAccountInfo.level, nextLevel = serverConnectedAccountInfo.nextLevel;
    var xpBar = React.createElement(XpBar, { level: level, xp: xp, nextLevel: nextLevel });
    var serverProfileQuickInfoDOM = (React.createElement(ProfileQuickInfo, { className: IdStyles.AnotherSaveSecondaryContainer, accountConnected: serverConnectedAccountInfo.accountConnected, onClick: onFromServerSelect, accountSourceLocaId: IdLoca.anotherSaveFound_onTheServer, xpBar: xpBar }));
    xpBar = React.createElement(HudXp, null);
    var webProfileQuickInfoDOM = (React.createElement(ProfileQuickInfo, { className: IdStyles.AnotherSavePrimaryContainer, accountConnected: webConnectedAccountInfo.accountConnected, onClick: onFromWebSelect, accountSourceLocaId: IdLoca.anotherSaveFound_onThisDevice_web, xpBar: xpBar }));
    return (React.createElement(DialogWrapper, { titleLocaId: IdLoca.anotherSaveFound_title, className: IdStyles.ModalBackgroundInfo, onClose: onClose },
        React.createElement("div", { className: "flex flex--around flex--aligned h100" },
            webProfileQuickInfoDOM,
            serverProfileQuickInfoDOM)));
};
var mapDispatch = function (dispatch) { return ({
    onClose: function () { return dispatch(actionModalClose(IdModal.FacebookConnectAnotherPlayerConnected)); },
    onFromServerSelect: function () { return dispatch(actionModalOpen(IdModal.FacebookConnectAnotherPlayerLogout)); },
    onFromWebSelect: function () { return dispatch(actionModalOpen(IdModal.FacebookConnectAnotherPlayerConnect)); },
}); };
var mapState = function (state) { return ({
    serverConnectedAccountInfo: selectFbConnectedServerAccount(state),
    webConnectedAccountInfo: selectFbConnectedWebAccount(state),
}); };
export var DialogFacebookAnotherPlayerConnected = connect(mapState, mapDispatch)(DialogFacebookAnotherPlayerConnectedDOM);



//////////////////
// WEBPACK FOOTER
// ./src/features/facebook/DialogFacebookAnotherPlayerConnected.tsx
// module id = 2825
// module chunks = 3